import { Component, OnInit, Input, Output, EventEmitter, ViewChildren} from '@angular/core';

import * as moment from 'moment';
import * as _ from 'lodash';

import { UtilService } from 'src/app/modules/shared/services/util.service';

interface IRange {
  value: Date[];
  label: string;
}

@Component({
  selector: 'app-page-filters',
  templateUrl: './page-filters.component.html',
  styleUrls: ['./page-filters.component.scss']
})
export class PageFiltersComponent implements OnInit {

  @Input() page: string; // Used page
  @Input() showManufacturer: boolean = true; // Show/hide manufacturer dropdown
  @Input() showBrand: boolean = true; // Show/hide brand dropdown
  @Input() showRetailer: boolean = true; // Show/hide retailer dropdown
  @Input() showStore: boolean = true; // Show/hide store dropdown
  @Input() showCalendar: boolean = true; // Show/hide date range
  @Input() showCouponSource: boolean = true; // Show/hide coupon source (cpg/national)
  @Input() showCouponStatus: boolean = true; // Show/hide coupon status (expired/active/upcoming)
  @Output() filterChange = new EventEmitter(); // Filer change event

  public loginData: any;
  public manufacturesData: any;
  public brandsData: any;
  public retailersData: any;

  public manufactures: any = [];
  public selectedManufacturer: any = 0;

  public brands: any = [];
  public selectedBrand: any = 0;

  public retailers: any = [];
  public selectedRetailer: any = 0;

  public stores: any = [];
  public selectedStore: any = 0;

  public calendarRanges: IRange[];
  public calendarConfig;
  public calendarMinDate: Date;
  public calendarMaxDate: Date;
  public dateRange: any = [];
  
  public couponSource: string; // cpg/national
  public couponStatus: string // expired/active/upcoming

  constructor(
    private _utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.getStorageData();
  }
  
  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('D_LOGIN');
    this.manufacturesData = await this._utilService.getStorageData('D_MANUFACTURERS');
    this.brandsData = await this._utilService.getStorageData('D_BRANDS');
    this.retailersData = await this._utilService.getStorageData('D_RETAILERS');

    // Calendar setings with timezone
    this.calendarRanges = [
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 0)), new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 0))],  label: 'Today'},
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 1)), new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 1))],  label: 'Yesterday'},
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 6)), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'))],  label: 'Last 7 Days'},
      { value: [new Date(new Date().setDate(new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')).getDate() - 29)), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'))],  label: 'Last 30 Days'},
    ];
    this.calendarConfig = { adaptivePosition: true, dateInputFormat: 'YYYY-MM-DD HH:mm', containerClass: 'theme-blue', showWeekNumbers: false, ranges: this.calendarRanges };
    this.calendarMinDate = new Date(moment().utcOffset(this.loginData.user_details.user_timezone).subtract(3, 'years').format('YYYY-MM-DD HH:mm'));
    this.calendarMaxDate = new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'));

    if (!this.selectedManufacturer && this.manufacturesData.length > 0) { // Set first manufacturer as default
      this.manufactures = this.manufacturesData;
      this.selectedManufacturer = this.manufactures[0].mfg_id; 

      this.brands = _.filter(this.brandsData, obj => obj.mfg_id == this.selectedManufacturer);
      if (this.brands.length > 0) {
        this.selectedBrand = this.brands[0].brand_id; // Set first brand of selected manufacturer as default
      }
    }

    if (this.retailersData.length > 0) { // Set first retailer as default
      this.retailers = this.retailersData;
      this.selectedRetailer = this.retailers[0].retailer_id; 

      if (this.retailers[0].stores.length > 0) {
        this.stores = this.retailers[0].stores;

        if (this.stores.length > 0) {
          this.selectedStore = this.retailers[0].stores[0].store_id; // Set first store of selected retailer as default
        }
      }
    }

    // Set default filters
    this.couponSource = 'national'; // ONLY NATIONAL FOR NOW
    this.couponStatus = 'active'; 

    // Send data to parent component if calandar is hiden
    if (!this.showCalendar) {
      this.filterChange.emit({ change: 'store', manufacturer: +this.selectedManufacturer, brand: +this.selectedBrand, retailer: +this.selectedRetailer, store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
    } else { // Set calendar default date as today
      this.dateRange = [new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'))];
    }
  }

  // On dropdown change
  onDropdownChange(event: any, mode: string) {
    if (mode == 'manufacturer') { 
      // Set brand list based on selected manufacturer
      this.brands = _.filter(this.brandsData, obj => obj.mfg_id == this.selectedManufacturer);

      if (this.brands.length > 0) {
        this.selectedBrand = this.brands[0].brand_id; // Set first brand of selected manufacturer as default
      } else {
        this.selectedBrand = 0;
      }

      this.filterChange.emit({ change: 'manufacturer', manufacturer: +this.selectedManufacturer, brand: +this.selectedBrand, retailer: +this.selectedRetailer, store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
    } else if (mode == 'brand') { 
      this.filterChange.emit({ change: 'brand', manufacturer: +this.selectedManufacturer, brand: +this.selectedBrand, retailer: +this.selectedRetailer, store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
    } else if (mode == 'retailer') { 
      // Set store list based on selected retailer
      let tempRetailer: any = _.filter(this.retailers, obj => obj.retailer_id == this.selectedRetailer);

      if (tempRetailer) {
        this.stores = tempRetailer[0].stores
        this.selectedStore = this.stores[0].store_id; // Set first store of selected retailer as default
      } else {
        this.stores = [];
        this.selectedStore = 0;
      }

      this.filterChange.emit({ change: 'retailer', manufacturer: +this.selectedManufacturer, brand: +this.selectedBrand, retailer: +this.selectedRetailer,  store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
    } else if (mode == 'store') {
      this.filterChange.emit({ change: 'store', manufacturer: +this.selectedManufacturer, brand: +this.selectedBrand, retailer: +this.selectedRetailer, store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
    }
  }

  // On calendar value change
  onCalendarValueChange(event: any) {
    this.dateRange = event;

    if (this.selectedStore && this.dateRange.length == 2 && this.couponSource) {
      this.filterChange.emit({ change: 'date_range', manufacturer: +this.selectedManufacturer, brand: +this.selectedBrand, retailer: +this.selectedRetailer, store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
    }
  }

  // Coupon source change
  oncouponSourceChange(source: string){
    this.couponSource = source;

    if (!this.showCalendar) { // Calandar is hiden
      if (this.selectedStore && this.couponSource) {
        this.filterChange.emit({ change: 'coupon_source', manufacturer: +this.selectedManufacturer, brand: +this.selectedBrand, retailer: +this.selectedRetailer, store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      }
    } else { // Calandar is visible
      if (this.selectedStore && this.dateRange.length == 2 && this.couponSource) {
        this.filterChange.emit({ change: 'coupon_source', manufacturer: +this.selectedManufacturer, brand: +this.selectedBrand, retailer: +this.selectedRetailer, store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      }
    }
  }

  // Coupon status change
  oncouponStatusChange(status: string){
    this.couponStatus = status;

    if (!this.showCalendar) { // Calandar is hiden
      if (this.selectedStore && this.couponStatus) {
        this.filterChange.emit({ change: 'coupon_status', manufacturer: +this.selectedManufacturer, brand: +this.selectedBrand, retailer: +this.selectedRetailer, store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      }
    } else { // Calandar is visible
      if (this.selectedStore && this.dateRange.length == 2 && this.couponStatus) {
        this.filterChange.emit({ change: 'coupon_status', manufacturer: +this.selectedManufacturer, brand: +this.selectedBrand, retailer: +this.selectedRetailer, store: +this.selectedStore, date_range: this.dateRange, coupon_source: this.couponSource, coupon_status: this.couponStatus});
      }
    }
  }

}
